<div class="network-settings" *ngIf="mustBePresented()">
  <div class="header">
    <div class="label">Network settings</div>
    <div class="description" >IP address</div>
  </div>
  <div class="network">
    <!-- dynamic IP/DHCP -->
    <div class="network-item">
      <div
        class="network-item-wrapper"
        [ngClass]="{'selected-network' : dynamicIPselected}"
        (click)="selectDynamicIP()"
      >
        <div class="network-icon"  [ngClass]="{'selected-icon' : dynamicIPselected}">
          <mat-icon>check_circle_outline</mat-icon>
        </div>
        <div class="network-item-content">
          <div class="label">Automatically assign (DHCP)</div>
        </div>
      </div>
    </div>

    <!-- static IP -->
    <div class="network-item">
      <div
        class="network-item-wrapper custom"
        [ngClass]="{'selected-network' : staticIPselected}"
        (click)="selectStaticIP()"
      >
      <div class="network-icon" [ngClass]="{'selected-icon' : staticIPselected}">
          <mat-icon>check_circle_outline</mat-icon>
        </div>
        <div class="network-item-content customContent">
          <div class="label">Manually assign</div>


        <form name="form"
          *ngIf="staticIPselected"
        >
          <div class="group">
            <p>Address *</p>
            <input
              autocomplete="off"
              placeholder="XXX.XXX.XXX.XXX"
              name="address"
              maxlength="20"
              [(ngModel)]="address"
              #addressInput="ngModel"
              (ngModelChange)="updates()"
              [pattern]="IP_REGEX"
              required
            />

            <div
              class="error"
              *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)"
            >
              <mat-error *ngIf="addressInput.errors.required"
                >Address is required.</mat-error
              >
              <mat-error *ngIf="addressInput.errors.pattern"
                >Address is not a valid IPv4 address.</mat-error
              >
            </div>
          </div>

          <div class="group">
            <p>Subnet mask *</p>
            <input
              autocomplete="off"
              placeholder="XXX.XXX.XXX.XXX"
              name="subnetMask"
              maxlength="15"
              [(ngModel)]="subnetMask"
              [pattern]="SUBNET_MASK_REGEX"
              #subnetMaskInput="ngModel"
              (ngModelChange)="updates()"
              required
            />

            <div
              class="error"
              *ngIf="subnetMaskInput.invalid && (subnetMaskInput.dirty || subnetMaskInput.touched)"
            >
              <mat-error *ngIf="subnetMaskInput.errors.required"
                >Subnet mask is required.</mat-error
              >
              <mat-error *ngIf="subnetMaskInput.errors.pattern"
                >Subnet mask is not valid.</mat-error
              >
            </div>
          </div>

          <div class="group">
            <p>Gateway *</p>
            <input
              autocomplete="off"
              placeholder="XXX.XXX.XXX.XXX"
              name="gateway"
              maxlength="15"
              [(ngModel)]="gateway"
              [pattern]="IP_REGEX"
              #gatewayInput="ngModel"
              (ngModelChange)="updates()"
              required
            />

            <div
              class="error"
              *ngIf="gatewayInput.invalid && (gatewayInput.dirty || gatewayInput.touched)"
            >
              <mat-error *ngIf="gatewayInput.errors.required"
                >Gateway is required.</mat-error
              >
              <mat-error *ngIf="gatewayInput.errors.pattern"
                >Gateway is not a valid IPv4 address.</mat-error
              >
            </div>
          </div>

          <div class="group">
            <p>Domain name server(s) *</p>
            <textarea
              placeholder="One address per line"
              name="dns"
              rows="3"
              [(ngModel)]="dns"
              required
              #dnsInput="ngModel"
              (ngModelChange)="updates()"
            >
            </textarea>

            <div
              class="error"
              *ngIf="dnsInput.invalid && (dnsInput.dirty || dnsInput.touched)"
            >
              <mat-error *ngIf="dnsInput.errors.required"
                >At least one DNS address is required.</mat-error
              >
              <mat-error *ngIf="dnsInput.errors.pattern"
                >At least one DNS address is not a valid IPv4
                address.</mat-error
              >
            </div>
          </div>
        </form>
      </div>
      </div>
    </div>
  </div>
  <!-- input controls to show for static IP -->
</div>
